import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import { HouseListDirectory } from '../../constants/ComponentTypes';
import Add from '../Icons/Add';
import Download from '../Icons/Download';
import Tabs, { Tab } from 'material-ui/Tabs';
import IconButton from 'material-ui/IconButton';

import { addCommas, isEnabledUserRole } from '../../utils/utils';
import { isEnableFollowCallHouseList } from '../../utils/userOptionUtils'

const styles = () => ({
  container: {
    width: '100%',
    margin: 0,
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'flex-start',
    backgroundColor: '#040E35',
    height: '68px',
    boxSizing: 'border-box',
    padding: '0px 0px 0px 20px',
    position: 'relative',
  },

  tabRoot: {
    fontSize: 15,
    textTransform: 'initial',
    transition: "120ms all linear",
    '&:hover, &[aria-selected=true]': {
      borderBottom: '2px solid #FFFFFF',
      color: '#FFFFFF',
      fontWeight: 'bold',
    },
    minWidth: '70px',
    border: 'none',
  },

  textColorPrimary: {
    color: '#71737B',
  },

  labelContainer: {
    padding: '10px 22px',
  },

  indicator: {
    background: 'none',
  },

  numberLabel: {
    backgroundColor: 'rgba(255, 255, 255, 0.15)',
    borderRadius: '9px',
    padding: '1px 8px',
    marginLeft: '6px',
    color: 'rgba(255, 255, 255, 0.5)',
    fontSize: '11px',
    fontWeight: 'bold',
    lineHeight: '14px',
  },

  buttonContainer: {
    zIndex: 1,
    position: 'absolute',
    right: '25px',
    bottom: 0,
    transform: 'translateY(50%)',
  },

  downloadButton: {
    background: '#FFFFFF',
    border: '1px solid #D8DBDF',
    '&:hover': {
      background: '#FFFFFF',
    }
  },

  addButton: {
    marginLeft: '15px',
    background: 'linear-gradient(180deg, #1A65FF, #032FE7)',
    boxShadow: '0px 5px 10px rgba(0, 0, 0, 0.16)',
  },
});

class AddressBookHeader extends React.Component {

  handleChange = (e, value) => {
    if (this.props.isDemo || this.props.disabled) {
      this.props.togglePlanDialog()
    } else {
      this.props.resetContainer();
      switch (value) {
        case HouseListDirectory.MAIN.name:
          this.props.goTo(HouseListDirectory.MAIN.path);
          break;
        case HouseListDirectory.WARNING.name:
          this.props.goTo(HouseListDirectory.WARNING.path);
          break;
        case HouseListDirectory.ERROR.name:
          this.props.goTo(HouseListDirectory.ERROR.path);
          break;
        case HouseListDirectory.NG_LIST.name:
          this.props.goTo(HouseListDirectory.NG_LIST.path);
          break;
        default:
          break;
      }
    }
  }

  renderLabel = (value) => {
    const { classes } = this.props;

    return (
      <div>
        {value}
        <span className={classes.numberLabel}>{addCommas(this.props.getCurrentTabTotal(value))}</span>
      </div>
    )
  }

  render() {
    const { classes, type, limitUsage, isDemo, disabled } = this.props;

    let currentTabTotal = this.props.getCurrentTabTotal();

    return (
      <div className={classes.container}>
        <Tabs
          value={this.props.type}
          onChange={this.handleChange}
          indicatorColor="primary"
          textColor="primary"
          classes={{
            indicator: classes.indicator,
          }}
        >
          {Object.values(HouseListDirectory).map((item, i) =>
          (<Tab
            classes={{
              root: classes.tabRoot,
              textColorPrimary: classes.textColorPrimary,
              labelContainer: classes.labelContainer,
            }}
            label={this.renderLabel(item.name)}
            key={i}
            value={item.name}
          >
          </Tab>))}
        </Tabs>

        <div className={classes.buttonContainer}>
          {isEnabledUserRole(this.props.user, "house-list", "download-list") && (
            <IconButton
              color="default"
              className={classes.downloadButton}
              onClick={isDemo || disabled ? this.props.togglePlanDialog : this.props.handleCsvExportAll}
              title="CSVエクスポート"
              disabled={currentTabTotal === 0}
              style={{ boxShadow: currentTabTotal === 0 ? 'none' : '0px 5px 10px rgba(0, 0, 0, 0.16)' }}
            >
              <Download width={24} height={24} color={currentTabTotal === 0 ? '#B1B3B9' : '#181819'} />
            </IconButton>
          )}

          {(() => {
            if (
              (isEnabledUserRole(this.props.user, "house-list", "edit")) && (
                type === HouseListDirectory.MAIN.name ||
                type === HouseListDirectory.NG_LIST.name
              )
            ) {
              return (
                <IconButton
                  color="primary"
                  className={classes.addButton}
                  onClick={(limitUsage || isDemo || disabled) ? this.props.togglePlanDialog : isEnableFollowCallHouseList(this.props.user) ? this.props.toggleSelectAddAddressDialog : this.props.toggleAddAddressDialog}
                  title="新規登録"
                >
                  <Add width={24} height={24} color="#FFFFFF" />
                </IconButton>
              )
            }
          })()}

        </div>
      </div>
    );
  }
}

AddressBookHeader.propTypes = {
  classes: PropTypes.object.isRequired,
  type: PropTypes.string.isRequired,
  goTo: PropTypes.func.isRequired,
  handleCsvExportAll: PropTypes.func.isRequired,
  resetContainer: PropTypes.func.isRequired,
  toggleAddAddressDialog: PropTypes.func.isRequired,
  toggleSelectAddAddressDialog: PropTypes.func.isRequired,
  getCurrentTabTotal: PropTypes.func.isRequired,
  isDemo: PropTypes.bool,
  disabled: PropTypes.bool,
  limitUsage: PropTypes.bool,
  togglePlanDialog: PropTypes.func.isRequired,
  user: PropTypes.object,
};

export default withStyles(styles)(AddressBookHeader);



// WEBPACK FOOTER //
// ./src/components/AddressBook/AddressBookHeader.jsx